<!-- 登录注册-手机验证码 -->
<template>
<div class="login">
    <a class="header wrap flex" href="https://www.rencaijob.com/" target="_blank">
        <img src="@/assets/logo.png" alt="">
    </a>
    <div class="login_center relative">
        <div class="wrap flex login_center_inner">
            <div class="login_form_left">
                <div class="title">
                    <span class="t1">海量人才</span>
                    <span class="t2">上人才职业网</span>
                </div>
                <div class="t3">好平台，新机遇</div>
                <img src="@/assets/login_img.png" alt="" class="login_img">
            </div>
            <div class="login-form">
                <a href="https://www.rencaijob.com/" target="_blank">
                    <img src="@/assets/logo.png" alt="" class="u-m-b-20">
                </a>
                <div>
                    <el-tabs v-model="tabCurrent" @tab-click="handleTab">
                        <el-tab-pane name="1" label="我要找工作">

                        </el-tab-pane>
                        <el-tab-pane name="2" label="我要招人">

                        </el-tab-pane>
                    </el-tabs>
                    <div class="u-padding-t-30">
                        <el-form :model="form">
                            <el-form-item>
                                <el-input placeholder="请输入手机号" clearable v-model="phone">
                                    <el-select class="internationalCode" slot="prepend" placeholder="请选择" v-model="nationalCode" @change="handleCommand">
                                        <el-option :value="item.internationalCode" v-for="(item, index) in countryPhoneList" :key="index">
                                            <div class="u-flex u-row-between">
                                                <span>{{ item.internationalCode }}</span> <span>{{ item.chinaName }}</span>
                                            </div>
                                        </el-option>
                                    </el-select>
                                </el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-input placeholder="请输入验证码" v-model="smsCode">
                                    <span slot="suffix">
                                        <el-button type='primary' v-show="phone && agreement" id="captcha-button" :disabled="disabled"> {{ text }} </el-button>
                                        <el-button type='primary' v-show="!phone || !agreement" @click="captchaVerify"> {{ text }} </el-button>
                                    </span>
                                </el-input>
                            </el-form-item>
                            <div class="link u-font-14 pointer u-m-b-20" v-html="prompt"></div>
                            <div class="u-flex u-row-between u-font-12">
                                <el-checkbox v-model="agreement">
                                    <span style="color: #999;" class="u-font-12">我已阅读 
                                        <span @click="agreementTap(1)" class="link">《服务协议》</span>
                                         和
                                        <span @click="agreementTap(2)" class="link">《隐私协议》</span>
                                    </span>
                                </el-checkbox>
                                <p class="link u-font-14 pointer">首次登录将自动注册</p>
                            </div>
                            <div class="u-padding-t-48 login_btn">
                                <el-button class="btn" @click="loginMobile" type="primary">登录</el-button>
                            </div>
                        </el-form>
                    </div>
                </div>
            </div>
        </div>
        <div class="ad" v-if="advertisingLeaflet">{{ advertisingLeaflet }}</div>
    </div>
    <div class="service_list wrap u-flex">
        <div class="service_item u-text-center">
            <div class="icon_box">
                <img src="@/assets/fxz_icon.png" alt="" />
            </div>
            <div class="t1">方向招</div>
            <div class="t2">人才</div>
        </div>
        <div class="service_item u-text-center">
            <div class="icon_box">
                <img src="@/assets/team_icon.png" alt="" />
            </div>
            <div class="t1">团队招</div>
            <div class="t2">团才</div>
        </div>
        <div class="service_item u-text-center">
            <div class="icon_box">
                <img src="@/assets/pizhao_icon.png" alt="" />
            </div>
            <div class="t1">批招批推</div>
            <div class="t2">批才</div>
        </div>
        <div class="service_item u-text-center">
            <div class="icon_box">
                <img src="@/assets/wujia_icon.png" alt="" />
            </div>
            <div class="t1">招聘五驾马</div>
            <div class="t2">全球人才</div>
        </div>
    </div>
    <div class="u-text-center footer">
        <div class="u-font-12 wrap">
            人才职业网rencaijob.com版权所有(2000-2023)，未经rencaijob.com同意，不得转载本站之所有招聘信息及作品 <br>
            京ICP备12043615号 增值电信业务经营许可证京B2-20190202 人才服务许可证RC1807126 营业执照 京公网安备11010502037028号<br>
            网站投诉电话：13911595711，北京市朝阳区人社局监督电话：010-57596212，65090445
        </div>
    </div>
    <div id="captcha-element"></div>
</div>
</template>

<script>
import sendVerifyCode from "@/mixins/SendVerifyCode";
import { getAdvertisingLeaflet, genScanQrKey, loginByKey, checkCaptcha, getCompanyUserInfo, getTalentUser, loginByCode, getCode, getCountryPhone } from "@/api/api";
import { setCookies } from "@/libs/util";
export default {
    name: 'Login_phoneCode',
    mixins: [sendVerifyCode],
    data() {
        return {
            tabCurrent: '2',
            form: {},
            smsCode: '',
            phone: '',
            captcha: "",
            keyCode: "",
            agreement: false,
            userAgreement: false,
            codeImage: '',
            code: '',
            uuid: '',
            captchaEnabled: false,
            internationalCode: '0086',
            fromPath: '',
            logo: '',
            codeUrl: '',
            codeImg: '',
            nationalCode: '0086',
            isSubmit: false,
            prompt:'',
            sceneId:'1w2w8wuk',
            captchaVerifyParam:{},
            countryPhoneList:[],
            qrcode:'',
            qrInterval:null,
            qrTimeout:null,
            isInvalidQRCode:false,
            advertisingLeaflet:''
        }
    },
    created() {
        this.getAdvertisingLeaflet();
        this.getCountry();
    },
    mounted() {
        this.captchaButton = document.getElementById('captcha-button');
        window.initAliyunCaptcha({
            SceneId: '1w2w8wuk', // 场景ID。根据步骤二新建验证场景后，您可以在验证码场景列表，获取该场景的场景ID
            prefix: '1ngw8w', // 身份标。开通阿里云验证码2.0后，您可以在控制台概览页面的实例基本信息卡片区域，获取身份标
            mode: 'popup', // 验证码模式。popup表示要集成的验证码模式为弹出式。无需修改
            element: '#captcha-element', // 页面上预留的渲染验证码的元素，与原代码中预留的页面元素保持一致。
            button: '#captcha-button', // 触发验证码弹窗的元素。button表示单击登录按钮后，触发captchaVerifyCallback函数。您可以根据实际使用的元素修改element的值
            captchaVerifyCallback: this.captchaVerifyCallback, // 业务请求(带验证码校验)回调函数，无需修改
            onBizResultCallback: this.onBizResultCallback, // 业务请求结果回调函数，无需修改
            getInstance: this.getInstance, // 绑定验证码实例函数，无需修改
            slideStyle: {
                width: 360,
                height: 40,
            }, // 滑块验证码样式，支持自定义宽度和高度，单位为px。其中，width最小值为320 px
            language: 'cn', // 验证码语言类型，支持简体中文（cn）、繁体中文（tw）、英文（en）
        });
    },
    beforeDestroy(){
        // this.stopQRLoginPolling();
        this.captchaButton = null;
        // 必须删除相关元素，否则再次mount多次调用 initAliyunCaptcha 会导致多次回调 captchaVerifyCallback
        document.getElementById('aliyunCaptcha-mask')?.remove();
        document.getElementById('aliyunCaptcha-window-popup')?.remove();
    },
    methods: {
        getAdvertisingLeaflet(){
            getAdvertisingLeaflet().then(res => {
                this.advertisingLeaflet = res.data
            })
        },
        getLoginCode(){
            genScanQrKey().then(res => {
                this.qrcode = res.data.key;
                this.isInvalidQRCode = false;
                // 启动轮询检查登录状态
                this.startQRLoginPolling();
                // 设置30秒后清除轮询
                this.qrTimeout = setTimeout(() => {
                    this.stopQRLoginPolling();
                    this.isInvalidQRCode = true;
                }, 180000);
            })
        },
         // 开始轮询检查登录状态
        startQRLoginPolling() {
        // 先立即检查一次
            this.checkQRLoginStatus();
            // 每3秒检查一次
            this.qrInterval = setInterval(() => {
                this.checkQRLoginStatus();
            }, 3000);
        },
        // 检查二维码登录状态
        checkQRLoginStatus() {
            if (!this.qrcode) return;
            loginByKey({
                key: this.qrcode
            }).then(res => {
                // 如果登录成功
                if (res.data && res.data.token) {
                    // 停止轮询
                    this.stopQRLoginPolling();
                    // 处理登录成功逻辑
                    this.handleLoginSuccess(res.data);
                }
            }).catch(err => {
                console.log('检查登录状态失败:', err);
                // 可以根据具体错误决定是否停止轮询
            });
        },

        // 停止轮询
        stopQRLoginPolling() {
            if (this.qrInterval) {
                clearInterval(this.qrInterval);
                this.qrInterval = null;
            }
            if (this.qrTimeout) {
                clearTimeout(this.qrTimeout);
                this.qrTimeout = null;
            }
        },
        // 处理登录成功
        handleLoginSuccess(data) {
            setCookies('token', data.token);
            if (data.userType == '2') {
                this.getCompanyUserInfo(data.status);
            } else if(data.userType == '1') {
                this.getTalentUser(data.status);
            }
        },
        handleTab(){
            this.refreshQRCode();
        },
        getCountry(){
            getCountryPhone()
            .then(res => {
                console.log(res);
                this.countryPhoneList = res.data;
            })
        },
        getInstance(instance) {
            this.captcha = instance;
        },
        async captchaVerifyCallback(captchaVerifyParam) {
            try{
                let result = await checkCaptcha({
                    captchaVerifyParam,
                    sceneId:this.sceneId
                })
                this.code = result.data.code;
                this.uuid = result.data.uuid;
                return {
                    captchaResult: result.data?.code ? true : false,
                    bizResult:true
                }
            }catch (e) {
                return {
                    captchaResult: false,
                    bizResult:true
                }
            }
        },
        // 验证通过后调用
        onBizResultCallback() {
            this.getCode();
        },
        handleCommand(command) {
            this.internationalCode = command;
            this.nationalCode = command;
            this.countryPhoneList.forEach(item => {
                if (item.internationalCode == command) {
                    this.prompt = item.prompt;
                }
            });
        },
        refreshQRCode() {
            this.stopQRLoginPolling();
            this.getLoginCode();
        },
        agreementTap(type) {
            location.href = 'https://rencaijob.com/personPlatform/ProtocolPage?typeList=' + type;
        },
        getCompanyUserInfo(status) {
            getCompanyUserInfo()
                .then(res => {
                    res.data.role = 1;
                    setCookies('userInfo', res.data);
                    this.$message.success("登录成功");
                    // 新用户登录跳转
                    if (status == '1') {
                        location.href = "https://rencaijob.com/bus/manage"
                    } else {//新用户登录跳转
                        location.href = "https://rencaijob.com/bus";
                    }
                })
        },
        getTalentUser(status) {
            getTalentUser()
                .then(res => {
                    res.data.role = 2;
                    setCookies('userInfo', res.data);
                    this.$message.success("登录成功");
                    // 新用户登录跳转
                    if (status == '1') {
                        location.href = "https://rencaijob.com/personPlatform/Register_guide";
                    } else {//新用户登录跳转
                        location.href = "https://rencaijob.com/personPlatform";
                    }
                })
        },
        captchaVerify(){
            const phoneRegex = /^1(3|4|5|7|8|9|6)\d{9}$/i; // 中国手机号
            const internationalPhoneRegex = /^\d{7,15}$/; // 国际手机号(E.164标准)
            if (!this.phone) return this.$message.error("请填写手机号码");
            if (!phoneRegex.test(this.phone) && !internationalPhoneRegex.test(this.phone)) return this.$message.error("请输入正确的手机号码");
            if (!this.agreement) return this.$message.error("请选择我已阅读《服务协议》和《隐私协议》");
        },
        async loginMobile() {
            const phoneRegex = /^1(3|4|5|7|8|9|6)\d{9}$/i; // 中国手机号
            const internationalPhoneRegex = /^\d{7,15}$/; // 国际手机号(E.164标准)
            let that = this;
            if (!that.phone) return that.$message.error("请填写手机号码");
            if (!phoneRegex.test(that.phone) && !internationalPhoneRegex.test(that.phone))
                return that.$message.error("请输入正确的手机号码");
            if (!that.smsCode) return that.$message.error("请填写验证码");
            if (!/^[\w\d]+$/i.test(that.smsCode))
                return that.$message.error("请输入正确的验证码");
            if (!that.agreement) return that.$message.error("请选择我已阅读《服务协议》和《隐私协议》");

            let userInfo = {
                phone: this.internationalCode + '-' + that.phone,
                smsCode: that.smsCode,
                userType: this.tabCurrent,
                source: 1,
                uuid: this.uuid,
                code: this.code
            };
            await loginByCode(userInfo).then((res) => {
                setCookies('token', res.data.token);
                if (this.tabCurrent == '2') {
                    this.getCompanyUserInfo(res.data.status)
                } else {
                    this.getTalentUser(res.data.status)
                }
            })
            .catch(err => {
                that.$message.error(err);
            });
        },
        getCode() {
          let that = this;
          const phoneRegex = /^1(3|4|5|7|8|9|6)\d{9}$/i; // 中国手机号
          const internationalPhoneRegex = /^\d{7,15}$/; // 国际手机号(E.164标准)
          if (!that.phone) return that.$message.error("请填写手机号码");
          if (!phoneRegex.test(that.phone) && !internationalPhoneRegex.test(that.phone))
                return that.$message.error("请输入正确的手机号码");
          if(this.isSubmit) return;
          this.isSubmit = true;
          getCode({
                  phone: that.internationalCode + '-' + that.phone,
                  userType: this.tabCurrent,
                  source: 1,
                  code: this.code,
                  uuid: this.uuid,
                  codeType: 1
              })
              .then(res => {
                console.log(res);
                  that.$message.success("验证码发送成功");
                  this.isSubmit = false;
                  that.sendCode();
              })
              .catch(err => {
                  that.$message.error(err);
                  that.smsCode = '';
                  this.isSubmit = false;
              });
        }
    }
}
</script>

<style lang="scss" scoped>
    .login{
        display: flex;
        flex-direction: column;
    }
    .flex{
        display: flex;
        align-items: center;
    }
    .header{
        height: 64px;
        background: #fff;
    }
    .login_center{
        min-height: 750px;
        background: url('@/assets/login_bg.png');
        background-position: center;
        background-size: cover;
        background-repeat: no-repeat;
        justify-content: space-between;
        width: 100%;
        line-height: 1;
        flex: 1;
    }
    .u-m-b-20{margin-bottom:20px;}
    .wrap{
        width: 1200px;
        margin: auto;
    }
    .login_center_inner{
        min-height: 750px;
        justify-content: space-between;
    }
    .u-padding-t-30{
        padding-top: 30px;
    }
    .login_form_left{
        width: 540px;
        padding-left: 40px;
        .title{
            span{color: #fff;}
            .t1{
                font-size: 38px;
            }
            .t2{
                font-size: 50px;
                margin-left: 16px;
            }
        }
        .t3{
            font-size: 32px;
            color: #fff;
            margin-top: 30px;
        }
        .login_img{
            display: block;
            margin: 83px 0 0 53px;
        }
    }
    .login {
        min-height: 100vh;
        .login-form {
            border-radius: 10px;
            width: 500px;
            padding: 32px 40px;
            background: #fff;
            .login-form-box {
                box-sizing: border-box;
                height: 100%;
                padding: 83px 100px;

                .btn {
                    width: 100%;
                    height: 56px;
                    border-radius: 5px;
                    font-size: 16px;
                }   
            }
            :deep(.el-tabs__item){
                height: 48px;
            }
            :deep(.el-tabs__item) {
                font-size: 20px;
                color: #666666;
                &.is-active {
                    color: #000;
                    font-weight: bold;
                }
            }
            :deep(.el-tabs__active-bar){
                background-color: #FF8F40;
            }
            :deep(.el-tabs__nav-wrap::after) {
                display: none;
            }
            :deep(.el-form-item__content) {
                line-height: 56px;
            }
            :deep(.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner){
                background-color: #FF8F40;
                border-color: #FF8F40;
            }
            :deep(.el-input__inner) {
                height: 56px;
                line-height: 56px;
            }

            :deep(.el-tabs__nav-wrap::after) {
                background-color: transparent;
            }

            :deep(.el-tabs__active-bar) {
                height: 4px;
            }

            :deep(.el-input--prefix .el-input__inner) {
                padding-left: 86px;
            }

            :deep(.el-input__prefix) {
                height: 100%;
                width: 68px;

                &::after {
                    width: 1px;
                    height: 24px;
                    content: '';
                    position: absolute;
                    top: 50%;
                    transform: translateY(-50%);
                    right: 0;
                    background-color: rgb(231, 231, 231);
                }
            }

            :deep(.el-input-group__prepend) {
                border: none;
                background-color: #fff;
                padding: 0 15px;
            }

            :deep(.el-input-group__prepend .el-input) {
                width: 110px;
            }

            :deep(.el-input-group) {
                border-radius: 5px;
                overflow: hidden;
                border: 1px solid rgba(235, 235, 235, 1);

                .el-input__inner {
                    border-radius: 0;
                    border: none;
                    background-color: #fff;
                }

                .el-input__icon {
                    height: 95%;
                }
            }
            :deep(.el-button--primary){background: #FF8F40;border-color: transparent;}
        }
        .link{
            color: #FF8F40;
        }
        .icp-box {
            color: rgba(153, 153, 153, 1);
        }
    }
    .u-font-12{
        font-size: 12px;
    }
    .u-font-14{font-size: 14px;}
    .internationalCode {
        :deep(.el-input--suffix) {
            height: 100%;
            width: 68px;

            &::after {
                width: 1px;
                height: 24px;
                content: '';
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                right: 0;
                background-color: rgb(231, 231, 231);
            }
        }
    }
    .code_img_wrap :deep(.el-input__suffix) {
        top: 6px;
    }

    .internationalCode :deep(.el-input__inner) {
        padding-left: 24px !important;
    }
    .relative {
        position: relative;
    }
    .u-font-bold{font-weight: bold;}
    .u-row-between{
        justify-content: space-between;
    }
    .u-flex{
        display: flex;
        align-items: center;
    }
    .login_btn{
        margin-top: 40px;
        margin-bottom: 15px;
        :deep(.el-button--primary){
            display: block;
            width: 100%;
            height: 56px;
        }
    }
    .u-text-right{text-align: right;}
    .u-text-center{text-align: center;}
    .footer{
        color: #fff;
        background: rgba(46, 46, 46, 1);
        padding: 24px 0;
        line-height: 1.5;
    }
    .service_list{
        padding: 24px 0;
        img{
            display: block;
        }
        .icon_box{
            display: flex;
            align-items: center;
            justify-content: center;
            width: 50px;
            height: 50px;
            margin: 0 auto 12px;
        }
        .t1{
            font-size: 14px;
            line-height: 26.06px;
            color: rgba(56, 56, 56, 1);
        }
        .t2{
            font-size: 12px;
            color: rgba(102, 102, 102, 1);
            line-height: 20.27px;
            margin-top: 4px;
        }
        .service_item{
            flex: 1;
        }
    }
    .ad{
        text-align: center;
        font-size: 25px;
        color: #fff;
        width: 100%;
        position: absolute;
        bottom: 30px;
        left: 0;
    }
</style>
